import { FC } from "react";
import { Role } from "../../../domain/models/Role";
import { RoleFields } from "../../../domain/enums/RoleFieldsEnum";
import RoleAddFeatureForm from "./RoleAddFeatureForm";
import AddRowsSVG from "../../../components/shared/svg/AddRowsSVG";

interface RoleTableRowProps {
    role: Role;
    updateHandler: (role: Role) => void;
}

const RoleTableRow: FC<RoleTableRowProps> = (props) => {
    const updateRoleHandler = () => {
        props.updateHandler(props.role);
    };

    return (
        <tr className="bg-light-bg-200 dark:bg-dark-bg-800 border-b hover:bg-gray-200 dark:hover:bg-dark-bg-800 border-light-border-200 dark:border-dark-border-200">
            {Object.values(RoleFields).map((value, index) => {
                return (
                    <td
                        key={`td-roles-table-${index}`}
                        className={`px-2 py-1 truncate ${
                            index === 0 ? "hover:whitespace-normal hover:overflow-visible hover:text-clip" : ""
                        } text-center max-w-[95px] border-light-border-200 dark:border-dark-border-200 border`}
                    >
                        {props.role[value]}
                    </td>
                );
            })}
            <td className="px-2 py-1 truncate text-center max-w-[95px] border-light-border-200 dark:border-dark-border-200 border">
                <div className="flex justify-center">
                    <RoleAddFeatureForm role={props.role} />
                </div>
            </td>
            {/* <td className="px-2 py-1 border-light-border-200 dark:border-dark-border-200 border text-center">
                <button
                    onClick={updateRoleHandler}
                    className="flex items-center justify-center rounded-[8px] bg-[#5CD685E5] hover:opacity-80 w-[28px] h-[28px] mx-auto"
                    title="Редагувати"
                >
                    <AddRowsSVG className="w-[16px] h-[16px] fill-light-bg-200 dark:fill-dark-bg-800" />
                </button>
            </td> */}
        </tr>
    );
};

export default RoleTableRow;
